<template>
    <ds-modal
        class="publish-template-modal"
        size="xl"
        is-open
        :title="$t('landingPages.publishModal')"
        show-close
        @close="$emit('closeModal')"
    >
        <div v-if="(isPublished && !hasChanges) || showPublishDetails" class="publish-modal-content published-content">
            <h3 class="publish-modal-title">
                {{ $t('landingPages.successfulPublish.title') }}
            </h3>
            <div class="publish-modal-text">
                {{ $t('landingPages.successfulPublish') }}
            </div>
            <hr />
            <p>{{ $t('landingPages.domainURL.subtext') }}</p>
            <div class="publish-modal-text">
                {{ customDomain ? $t('landingPages.customDomainUrl') : $t('landingPages.keapHostedDomain') }}
            </div>
            <div class="site-url-input-container">
                <ds-input-field
                    v-model="keapLinkUrl"
                    readonly
                    data-qa="url-input"
                    class="slug-url"
                    type="text"
                />
                <ds-filled-button class="copy-button" leading-icon="copy" @click="copySiteLink">
                    {{ $t('landingPages.copySiteUrl.button') }}
                </ds-filled-button>
            </div>
            <ds-link
                external
                class="domain-settings-link"
                trailing-icon="external-link"
                :href="domainSettingsUrl"
            >
                {{ $t('landingPages.domainSettings.link') }}
            </ds-link>
            <hr />
            <p>{{ $t('landingPages.keapEmbedCode.subtext') }}</p>
            <div class="publish-modal-text">
                {{ $t('landingPages.keapEmbedCode') }}
            </div>
            <div class="embed-code-input-container">
                <ds-text-area-field
                    v-model="marketingSiteEmbedCode"
                    readonly
                    data-qa="embed-code-input"
                    class="embed-code"
                />
                <ds-filled-button class="copy-button" leading-icon="copy" @click="copyEmbedCode">
                    {{ $t('landingPages.copyEmbedCode.button') }}
                </ds-filled-button>
            </div>
            <div class="actions">
                <ds-filled-button
                    type="submit"
                    @click="$emit('goToList')"
                >
                    {{ $t('landingPages.goToList.button') }}
                </ds-filled-button>
                <ds-text-button @click="$emit('closeModal')">
                    {{ $t('landingPages.backToEditor.button') }}
                </ds-text-button>
            </div>
        </div>
        <div v-else class="publish-modal-content unpublished-content">
            <div class="publish-modal-text">
                {{ $t('landingPages.confirmPublish') }}
            </div>
            <ds-outline-button
                v-if="showPublishLater"
                class="publish-later-button"
                @click="handlePublishLater"
            >
                {{ $t('landingPages.publishLater.button') }}
            </ds-outline-button>
            <div class="actions">
                <ds-text-button @click="$emit('closeModal')">
                    {{ $t('landingPages.backToEditor.button') }}
                </ds-text-button>

                <ds-spinner v-if="isPublishing" :size="40" />
                <ds-filled-button
                    v-else
                    type="submit"
                    @click="$emit('publish')"
                >
                    {{ $t('global.publish') }}
                </ds-filled-button>
            </div>
        </div>
    </ds-modal>
</template>

<script>
import { MARKETING_SITES } from '@/components/shared/constants/shareFeedback.constants';
import { SITE_STATUS } from '../util/marketing/unlayer.constants';

export default {
    MARKETING_SITES,
    name: 'MarketingSiteEditor',

    components: {},
    props: {
        customDomain: {
            type: Object,
            default: null,
        },
        isSaving: Boolean,
        isPublishing: Boolean,
        hasChanges: Boolean,
        keapLinkUrl: String,
        marketingSiteEmbedCode: String,
        domainSettingsUrl: String,
        isPublished: Boolean,
    },

    data() {
        return {
            showPublishDetails: false,
        };
    },

    computed: {
        showPublishLater() {
            return [SITE_STATUS.PUBLISHED || SITE_STATUS.PUBLISHED_CHANGES].includes(this.status);
        },
    },

    emits: {
        goToList: () => {},
        closeModal: () => {},
        publish: () => {},
    },

    methods: {
        async copyEmbedCode() {
            return this.copyText(this.marketingSiteEmbedCode);
        },

        async copySiteLink() {
            return this.copyText(this.keapLinkUrl);
        },

        async copyText(text) {
            try {
                await this.$copyText(text);
                this.$toast({ message: this.$t('landingPages.copyClipboard.success') });
            } catch (err) {
                this.$error({ message: this.$t('landingPages.copyClipboard.error'), bottom: true });
            }
        },

        handlePublishLater() {
            this.showPublishDetails = true;
        },
    },
};

</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.publish-template-modal {
    .domain-settings-link {
        display: flex;
        place-content: flex-end;
    }
    .publish-modal-content {
        margin: 1rem 1rem 0;
    }
    .publish-modal-title {
        margin: auto auto 2rem;
        font-family: Ivar Soft,Times New Roman;
        font-weight: 700;
        max-width: 31.25rem;
        font-size: 2rem;
    }
    .publish-modal-text {
        font-size: $font-size-lg;
    }
    .actions {
        display: flex;
        place-content: end;
        padding-top: 2rem;
        .button {
            margin-left: 1rem;
        }
    }
    .publish-later-button {
        display: block;
        margin: 1.5rem auto 0;
    }
    .copy-button {
        margin: auto;
        white-space: nowrap;
    }
    .site-url-input-container {
        display: flex;
        place-content: space-between;

        .input-field {
            margin: 1rem 1rem 1rem 0;
        }
    }
    .embed-code-input-container {
        margin-top: 1rem;
        display: block;
        text-align: right;
    }
}

</style>
